//touch-hover
window.addEventListener("load", () => {
  let touchElmList = document.querySelectorAll(".js-touch-hover");
  let touchElmListArr = Array.prototype.slice.call(touchElmList);
  touchElmListArr.forEach((touchElm) => {
    touchElm.addEventListener(
      "touchstart mouseenter",
      (e) => {
        e.target.classList.add("is-touch-hover");
      },
      false
    );
    touchElm.addEventListener(
      "touchend touchmove mouseleave click",
      (e) => {
        e.target.classList.remove("is-touch-hover");
      },
      false
    );
  });
});
